import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  copy({ params: { target } }) {
    const el = document.getElementById(target);
    if (el) navigator.clipboard.writeText(el.value);
  }

  select({ currentTarget }) {
    currentTarget.select();
  }
}
